export default {
  startIndex(state, getters) {
    return state.currentPage * state.projects.length + 1
  },
  endIndex(state, getters) {
    return getters['startIndex'] + Math.min(state.projects.length - 1, state.pageSize)
  },
};
